














































































import { Vue, Component, Prop } from "vue-property-decorator";
import SelectOption from "./SelectOption.vue";
import SelectTile from "./SelectTile.vue";
import {
  TemplateInput,
  InputHeader,
  HEADER_TYPES
} from "@/store/template/types";

@Component({
  components: {
    SelectOption,
    SelectTile
  }
})
export default class ColumnInput extends Vue {
  store = this.$store.direct;

  @Prop() input!: TemplateInput;
  @Prop() headers!: InputHeader[];

  form: InputHeader = {
    name: "",
    type: "text",
    label: "",
    required: true,
    options: []
  };

  get valid() {
    return (
      this.form.name &&
      this.form.name.length > 0 &&
      this.form.type &&
      this.form.type.length > 0 &&
      (this.form.type == "select" && this.form.options
        ? this.form.options.length > 0
        : true)
    );
  }

  rules = {
    required: (v: any) => !!v || "Este campo es obligatorio",
    unique: (v: string) =>
      !this.variables.includes(v) || "El nombre " + v + " se encuentra en uso"
  };

  get headerTypes() {
    return HEADER_TYPES;
  }

  get variables() {
    let local = [this.input.name as string];
    if (this.input.headers) {
      this.input.headers.forEach(header => {
        local.push(header.name);
      });
    }
    return this.store.getters.template.usedVariables.concat(local);
  }

  save() {
    this.input.headers.push(this.form);
    this.form = {
      name: "",
      type: "text",
      label: "",
      required: true,
      options: []
    };
  }
}
